import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  select: {
    width: 76,
  },
  result: {
    flex: 1,
    paddingLeft: 12,
  },
  text: {
    flex: 1,
    paddingLeft: 12,
    textAlign: "right",
  },
  pagination: {
    paddingLeft: 12,
  },
}));
